module.exports = __webpack_public_path__ + "img/wedding.55dd86f2.jpg";